import React from 'react';
import { Institution } from '../../types/institution';
import BankSearchResult from './BankSearchResult';
import './SearchResults.css';

interface SearchResultsProps {
  searchResults: Institution[];
  isSearching: boolean;
  searchTerm: string;
  hasSearchResults: boolean;
  onBankSelect: (institution: Institution) => void;
}

const SearchResults: React.FC<SearchResultsProps> = ({
  searchResults,
  isSearching,
  searchTerm,
  hasSearchResults,
  onBankSelect
}) => {
  if (!hasSearchResults) {
    return null;
  }

  if (isSearching) {
    return (
      <div className="search-results">
        <div className="search-loading">Searching...</div>
      </div>
    );
  }

  if (searchResults.length === 0) {
    return (
      <div className="search-results">
        <div className="no-results">No banks found matching "{searchTerm}"</div>
      </div>
    );
  }

  return (
    <div className="search-results">
      {searchResults.map((institution, index) => (
        <BankSearchResult
          key={institution.id}
          institution={institution}
          showDivider={index < searchResults.length - 1}
          onClick={onBankSelect}
        />
      ))}
    </div>
  );
};

export default SearchResults; 